export default __webpack_public_path__ + "static/media/quiz_bg.9991b386.png";